(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-stock-notice"] && !Shopify.designMode) return;
  try {
    class VariantStockNotice extends HTMLElement {
    connectedCallback() {
      this.variants = this.readVariants();
      this.text = this.querySelector('.variant-stock-notice__text');
      this.productForm = this.closest('product-info, .product, .product__info-wrapper, form') || document;
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('change', this.onVariantChange);
      document.addEventListener('variant:change', this.onVariantChange);
      document.addEventListener('variantChange', this.onVariantChange);
      this.renderFromSelectedVariant();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      document.removeEventListener('variant:change', this.onVariantChange);
      document.removeEventListener('variantChange', this.onVariantChange);
    }

    readVariants() {
      try {
        return JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]');
      } catch (error) {
        return [];
      }
    }

    onVariantChange(event) {
      const eventVariant = event.detail?.variant;
      if (eventVariant?.id) {
        this.render(eventVariant.id);
        return;
      }

      // Theme pickers commonly update their hidden [name="id"] input just
      // after the radio/select change. Let that update finish first.
      window.setTimeout(() => this.renderFromSelectedVariant(), 0);
    }

    renderFromSelectedVariant() {
      const idInput = this.productForm.querySelector?.('[name="id"]') || document.querySelector('[name="id"]');
      this.render(idInput?.value);
    }

    render(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (!variant || !variant.available) {
        this.hidden = true;
        return;
      }

      const quantity = this.dataset.mode === 'demo'
        ? this.demoQuantity(variant.id)
        : Number(variant.inventory_quantity);

      // In real-inventory mode do not claim scarcity for an untracked or
      // out-of-stock variant, or one above the configured threshold. Demo
      // mode deliberately works without inventory tracking.
      const maxVisible = Number(this.dataset.maxVisible);
      const requiresTrackedInventory = this.dataset.mode !== 'demo';
      if ((requiresTrackedInventory && !variant.inventory_management) || !Number.isFinite(quantity) || quantity < 1 || quantity > maxVisible) {
        this.hidden = true;
        return;
      }

      const noun = quantity === 1
        ? (this.dataset.nounSingular || 'piece')
        : (this.dataset.nounPlural || 'pieces');
      const message = this.dataset.message
        .replace('[quantity]', quantity)
        .replace('[size]', this.sizeLabel(variant))
        .replace('[noun]', noun);

      this.text.textContent = message;
      this.hidden = false;
    }

    sizeLabel(variant) {
      try {
        const optionNames = JSON.parse(this.dataset.productOptions || '[]');
        const sizeIndex = optionNames.findIndex((name) => /size|taglia|maat|talla|taille|gr[oö]sse/i.test(name));
        if (sizeIndex >= 0 && variant.options?.[sizeIndex]) return variant.options[sizeIndex];
      } catch (error) {
        // A generic variant title remains a safe fallback for older themes.
      }
      return variant.title;
    }

    demoQuantity(variantId) {
      const minimum = Number(this.dataset.minimum);
      const maximum = Number(this.dataset.maximum);
      const low = Math.min(minimum, maximum);
      const high = Math.max(minimum, maximum);
      const range = high - low + 1;
      const seed = `${this.dataset.productId}:${variantId}`;
      let hash = 0;

      // A deterministic test value prevents the message changing every time
      // the customer revisits the same size during one campaign session.
      for (let index = 0; index < seed.length; index += 1) {
        hash = ((hash << 5) - hash + seed.charCodeAt(index)) | 0;
      }
      return low + (Math.abs(hash) % range);
    }
  }

  if (!customElements.get('variant-stock-notice')) {
    customElements.define('variant-stock-notice', VariantStockNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
